/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

interface IAccountLoyaltyTileDescription {
    description: string;
}

// eslint-disable-next-line no-redeclare
const IAccountLoyaltyTileDescription: React.FC<IAccountLoyaltyTileDescription> = ({ description }) => (
    <p className='ms-account-loyalty-tile__description'>{description}</p>
);

export default IAccountLoyaltyTileDescription;
